import {CoreGraphNode} from '../../../../@polygonjs/polygonjs/src/core/graph/CoreGraphNode';
import {SceneEvent} from '../../../../@polygonjs/polygonjs/src/engine/poly/SceneEvent';
import {NodeEvent} from '../../../../@polygonjs/polygonjs/src/engine/poly/NodeEvent';
import {ParamEvent} from '../../../../@polygonjs/polygonjs/src/engine/poly/ParamEvent';
import {PolyScene} from '../../../../@polygonjs/polygonjs/src/engine/scene/PolyScene';

import {EditorStoreController, EditorStoreControllerClass} from './EditorStoreController';
import {EngineStoreController, EngineStoreControllerClass} from './EngineStoreController';
import {Store} from 'vuex';
import {State} from '../Store';
import {AVAILABLE_LINK_INDEX_VALUES} from '../../components/panels/common/LinkIndex';

class StoreControllerClass {
	private static _instance: StoreControllerClass;
	private _scene!: PolyScene;

	public readonly editor: EditorStoreControllerClass = EditorStoreController;
	public readonly engine: EngineStoreControllerClass = EngineStoreController;

	static instance() {
		return (this._instance = this._instance || new StoreControllerClass());
	}

	private constructor() {}
	set_scene(scene: PolyScene) {
		this._scene = scene;
		this._scene.dispatchController.setListener(this);
		this.editor.set_scene(scene);
		this.engine.set_scene(scene);

		AVAILABLE_LINK_INDEX_VALUES.forEach((linkIndex) => {
			this.editor.setCurrentNode(linkIndex, scene.root(), {pushToHistory: false});
		});
	}
	get scene() {
		return this._scene;
	}
	// async save_scene() {
	// 	Editor.instance().save();
	// }
	// async new_scene() {
	// 	Editor.instance().new_scene();
	// }

	set_store(store: Store<State>) {
		(window as any).store = store;
		this.editor.set_store(store);
		this.engine.set_store(store);
	}

	closeAllPopups() {
		this.editor.closeAllPopups();
	}

	process_events(emitter: CoreGraphNode, event_name: SceneEvent | NodeEvent | ParamEvent, data?: any): void {
		const id = emitter.graphNodeId();
		switch (event_name) {
			// scene events
			case SceneEvent.FRAME_UPDATED:
				return this.engine.update_frame();
			case SceneEvent.MAX_FRAME_UPDATED:
				return this.engine.update_frame_range();
			case SceneEvent.REALTIME_STATUS_UPDATED:
				return this.engine.update_realtimeState();
			case SceneEvent.PLAY_STATE_UPDATED:
				return this.engine.update_play_state();

			// node events
			case NodeEvent.ERROR_UPDATED:
				return this.engine.update_node_error(id);
			case NodeEvent.UI_DATA_POSITION_UPDATED:
				return this.engine.update_node_ui_data_position(id);
			case NodeEvent.UI_DATA_COMMENT_UPDATED:
				return this.engine.update_node_ui_data_comment(id);
			case NodeEvent.SELECTION_UPDATED:
				return this.engine.update_node_selection(id);
			case NodeEvent.FLAG_DISPLAY_UPDATED:
				return this.engine.update_node_display_flag(id);
			case NodeEvent.FLAG_BYPASS_UPDATED:
				return this.engine.update_node_bypass_flag(id);
			case NodeEvent.FLAG_OPTIMIZE_UPDATED:
				return this.engine.update_node_optimize_flag(id);
			case NodeEvent.NAME_UPDATED:
				return this.engine.update_node_name(id);
			case NodeEvent.INPUTS_UPDATED:
				return this.engine.update_node_inputs(id);
			case NodeEvent.OVERRIDE_CLONABLE_STATE_UPDATE:
				return this.engine.update_node_clonable_state(id);
			case NodeEvent.NAMED_INPUTS_UPDATED:
				return this.engine.update_node_named_inputs(id);
			case NodeEvent.NAMED_OUTPUTS_UPDATED:
				return this.engine.update_node_named_outputs(id);
			case NodeEvent.PARAMS_UPDATED:
				return this.engine.update_params(id);
			case NodeEvent.CREATED:
				return this.engine.add_node(id, data);
			case NodeEvent.DELETED:
				return this.engine.delete_node(id, data);

			// param events
			case ParamEvent.RAW_INPUT_UPDATED:
				return this.engine.update_param_raw_input(id);
			case ParamEvent.VALUE_UPDATED:
				return this.engine.update_param_value(id);
			case ParamEvent.EXPRESSION_UPDATED:
				return this.engine.update_param_expression(id);
			case ParamEvent.ERROR_UPDATED:
				return this.engine.update_param_error(id);
			case ParamEvent.VISIBLE_UPDATED:
				return this.engine.update_param_visible_state(id);
			case ParamEvent.EDITABLE_UPDATED:
				return this.engine.update_param_editable_state(id);
		}
	}
}

export const StoreController = StoreControllerClass.instance();
